<template>
  <div id="Import_testing_center" class="xv_modal">
    <div class="modal_title">
      <div>
        <span>Import Testing Center</span>
      </div>
      <div>
        <button class="modal_close" @click="close_import_testing_center()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content">
      <div class="import_office">
        <div class="import" @click="$refs.file_import.click()">
          <span>
            <span class="mdi mdi-file-import"></span> Upload file
          </span>
          <input type="file" ref="file_import" />
        </div>
        <div class="sample">
          <a href="#">
            Sample excel
            <span class="mdi mdi-download"></span>
          </a>
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <button class="sec_btn m_r" @click="close_import_testing_center()">Cancel</button>
      <button class="main_btn">Import</button>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Import_testing_center",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      step_count: 1
    };
  },
  methods: {
    close_import_testing_center: function() {
      this.$modal.hide("import_testing_center");
    }
  }
};
</script>
